import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormSummary } from './form-summary';
import { SharedModule } from 'app/shared/shared.module';
import { SurveyProjectMeetingModule } from '../../survey-project-meeting/survey-project-meeting.module';
import { SurveyProjectAdviceModule } from '../../survey-project-advice/survey-project-advice.module';


@NgModule({
  declarations: [
    FormSummary,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SurveyProjectMeetingModule,
    SurveyProjectAdviceModule,
  ],
  exports: [
    FormSummary
  ]
})
export class FormSummaryModule { }
